<!-- ProductMediaManager.vue – Refactored with Media & Playlist sections -->
<template>
  <div class="product-media-manager">
    <b-overlay :show="loading" rounded="lg">
      <!-- Header -->


      <!-- Tabs -->
      <b-tabs v-model="activeTab" class="mb-3">

        <!-- Media Tab -->
        <b-tab title="فایل‌های رسانه" active>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div>
              <h4 class="mb-0">
                <feather-icon icon="ApertureIcon" size="20"></feather-icon>
                مدیریت رسانه محصول
              </h4>
            </div>
            <b-button variant="primary" @click="openAttachModal">
              <feather-icon icon="PlusIcon"></feather-icon>
              پیوست فایل
            </b-button>
          </div>
          <!-- Media Grid -->
          <div v-if="mediaItems.length === 0" class="text-center py-5">
            <feather-icon icon="FolderIcon" size="50"></feather-icon>
            <p class="mt-3">هیچ فایلی به این محصول پیوست نشده است.</p>
            <b-button variant="primary" size="sm" @click="openAttachModal">
              <i class="fas fa-plus"></i> پیوست فایل
            </b-button>
          </div>

          <b-row v-else>
            <b-col
                v-for="media in mediaItems"
                :key="media.id"
                cols="12"
                sm="6"
                md="4"
                lg="3"
                xl="3"
                class="mb-4"
            >
              <b-card class="media-card">
                <!-- Thumbnail / Icon -->
                <div class="media-thumb-wrapper position-relative">
                  <b-img
                      v-if="getFullUrl(media.thumbnailUrl)"
                      :src="getFullUrl(media.thumbnailUrl)"
                      :alt="media.title  || 'رسانه'"
                      fluid
                      class="media-thumb-img"
                  />
                  <div v-else class="media-thumb-icon d-flex align-items-center justify-content-center">
                    <feather-icon :icon="getFileIcon(media.mediaType)" size="50"></feather-icon>
                  </div>

                  <!-- Badges -->
                  <span v-if="media.isMain" class="badge badge-warning position-absolute top-0 left-0 m-2">اصلی</span>
                  <span v-if="media.isLocked" class="badge badge-secondary position-absolute top-0 right-0 m-2">
                    <i class="fas fa-lock"></i>
                  </span>
                  <span v-if="!media.isReachable" class="badge badge-danger position-absolute bottom-0 left-0 m-2">خصوصی</span>
                </div>

                <!-- Info -->
                <b-card-body>
                  <b-card-title class="media-title text-truncate" :title="media.title">
                    {{ media.title || 'بدون عنوان' }}
                  </b-card-title>
                  <b-card-text class="media-meta text-muted small">
                    <span>{{ getMediaTypeLabel(media && media.mediaType) }}</span>
                    <span class="mx-1">·</span>
                    <span>{{ formatSize(media && media.size || 0) }}</span>
                    <span class="mx-1">·</span>
                    <span>اولویت: {{ media.priority || 0 }}</span>
                  </b-card-text>

                  <!-- Actions -->
                  <div class="d-flex flex-wrap mt-2">
                    <b-button
                        size="sm"
                        variant="outline-info"
                        class="mr-1 mb-1"
                        @click.stop="viewDetail(media)"
                    >
                      <feather-icon icon="EyeIcon" size="14"></feather-icon>
                      مشاهده جزئیات
                    </b-button>
                    <b-button
                        size="sm"
                        :variant="media.isLocked ? 'outline-warning' : 'outline-secondary'"
                        class="mr-1 mb-1"
                        @click.stop="toggleLock(media)"
                    >
                      <i :class="media.isLocked ? 'fas fa-unlock' : 'fas fa-lock'"></i>
                      {{ media.isLocked ? 'باز کردن' : 'قفل' }}
                    </b-button>
                    <b-button
                        size="sm"
                        variant="outline-danger"
                        class="mr-1 mb-1"
                        @click.stop="confirmDetach(media)"
                    >
                      <i class="fas fa-unlink"></i> جدا کردن
                    </b-button>
                  </div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>

        <!-- Playlists Tab -->
<!--        <b-tab title="پلی‌لیست‌ها">-->

<!--          <ProductPlaylistManager-->
<!--              :product-id="productId"-->
<!--              @refresh="fetchMedia"-->
<!--          />-->
<!--        </b-tab>-->
      </b-tabs>
    </b-overlay>

    <!-- Attach Media Modal -->
    <ProductMediaPickerModal
        ref="attachModal"
        :product-id="productId"
        @attached="onMediaAttached"
    />

    <!-- Detail Modal -->
    <FileDetailModal
        disableActions
        :file="detailFile"
        @updated="handleFileUpdated"
    />
  </div>
</template>

<script>
import {BButton, BCard, BCardBody, BCardText, BCardTitle, BCol, BImg, BOverlay, BRow, BTab, BTabs} from 'bootstrap-vue'
import {
  ProductMediaDetachFileRequest,
  ProductMediaGetByProductRequest,
  ProductMediaToggleLockRequest
} from '@/libs/Api/ProductMedia'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Helper from '@/libs/Helper'
import ProductMediaPickerModal from "@/views/components/Library/ProductMediaPickerModal.vue"
import FileDetailModal from "@/views/components/Library/FileDetailModal.vue"
import {MediaLibraryGetFileRequest} from "@/libs/Api/MediaLibrary"
import ProductPlaylistManager from "@/views/components/Library/ProductPlaylistManager.vue";

export default {
  name: 'ProductMediaManager',
  components: {
    ProductPlaylistManager,
    ProductMediaPickerModal,
    FileDetailModal,
    BOverlay,
    BButton,
    BRow,
    BCol,
    BCard,
    BImg,
    BCardBody,
    BCardTitle,
    BCardText,
    BTabs,
    BTab,
  },

  data: function () {
    return {
      loading: false,
      activeTab: 'media',
      productId: this.$route.params.id,
      mediaItems: [],
      baseUrl: Helper.baseUrl || 'https://demoapi.lenzava.com',
      detailFile: null,
    }
  },
  created: function () {
    this.fetchMedia()
  },
  methods: {
    // ===== Helper Methods =====
    getFullUrl: function (path) {
      if (!path) return null
      if (path.startsWith('http://') || path.startsWith('https://')) return path
      var cleanPath = path.startsWith('/') ? path.substring(1) : path
      return this.baseUrl + cleanPath
    },
    getFileIcon: function (type) {
      var map = { 1: 'CameraIcon', 2: 'VideoIcon', 3: 'MusicIcon', 4: 'FileIcon' }
      return map[type] || 'fa-file'
    },
    getMediaTypeLabel: function (type) {
      var map = { 1: 'تصویر', 2: 'ویدیو', 3: 'صوتی', 4: 'سند' }
      return map[type] || 'ناشناخته'
    },
    formatSize: function (bytes) {
      if (bytes === 0) return '0 B'
      var k = 1024
      var sizes = ['B', 'KB', 'MB', 'GB', 'TB']
      var i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    },
    showToast: function (variant, title, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'bottom-center',
        props: {
          title: title,
          icon: variant === 'success' ? 'CheckIcon' : 'XIcon',
          variant: variant,
          text: text
        }
      })
    },

    // ===== View Detail =====
    viewDetail: function (media) {
      var self = this
      self.loading = true
      var request = new MediaLibraryGetFileRequest(this)
      request.setParams(media.id)
      request.fetch(
          function (content) {
            self.detailFile = content
            self.$bvModal.show('modal-detail')
            self.loading = false
          },
          function (error) {
            self.loading = false
            self.showToast('error', 'خطا در دریافت جزئیات', error.message)
          }
      )
    },
    handleFileUpdated: function () {
      this.fetchMedia()
    },

    // ===== Fetch Data =====
    fetchMedia: function () {
      var self = this
      self.loading = true
      var request = new ProductMediaGetByProductRequest(this)
      request.setParams({ productId: this.productId })
      request.fetch(
          function (content) {
            self.mediaItems = content.data || []
            self.loading = false
          },
          function (error) {
            self.loading = false
            self.showToast('error', 'خطا در بارگذاری رسانه', error.message)
          }
      )
    },

    // ===== Attach Media =====
    openAttachModal: function () {
      this.$bvModal.show('modal-product-attach')
    },
    onMediaAttached: function () {
      this.fetchMedia()
    },

    // ===== Detach Media =====
    confirmDetach: function (media) {
      var self = this
      var title = media.title || (media.fileEntry && media.fileEntry.title) || 'این فایل'
      this.$bvModal.msgBoxConfirm(
          'آیا از جدا کردن "' + title + '" از محصول اطمینان دارید؟',
          {
            title: 'تأیید جدا کردن',
            okVariant: 'danger',
            okTitle: 'جدا کردن',
            cancelTitle: 'لغو',
            headerBgVariant: 'transparent',
            headerTextVariant: 'light'
          }
      ).then(function (confirmed) {
        if (confirmed) {
          self.detachMedia(media.mediaId)
        }
      })
    },
    detachMedia: function (mediaId) {
      var self = this
      self.loading = true
      var request = new ProductMediaDetachFileRequest(this)
      request.setParams({ mediaId: mediaId })
      request.fetch(
          function () {
            self.loading = false
            self.fetchMedia()
          },
          function (error) {
            self.loading = false
          }
      )
    },

    // ===== Toggle Lock =====
    toggleLock: function (media) {
      var self = this
      self.loading = true
      var request = new ProductMediaToggleLockRequest(this)
      request.setParams({ mediaId: media.id })
      request.fetch(
          function () {
            self.loading = false
            media.isLocked = !media.isLocked
            var msg = media.isLocked ? 'فایل قفل شد.' : 'قفل فایل باز شد.'
            // self.showToast('success', 'موفق', msg)
          },
          function (error) {
            self.loading = false
            // self.showToast('error', 'خطا', error.message)
          }
      )
    },
  }
}
</script>

<style scoped>
.product-media-manager {
  padding: 0.5rem 0;
}

.media-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  transition: all 0.2s ease;
}

.media-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.media-thumb-wrapper {
  width: 100%;
  aspect-ratio: 1/1;
  background: #f1f5f9;
  overflow: hidden;
}

.media-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-thumb-icon {
  width: 100%;
  height: 100%;
  color: #94a3b8;
}

.media-title {
  font-weight: 600;
  font-size: 14px;
}

.media-meta {
  font-size: 11px;
  color: #94a3b8;
}
</style>
